module.exports = __webpack_public_path__ + "static/media/img-01@2x.e4e351cb.png";